import { render } from "./GaoJing.vue?vue&type=template&id=43ae3c9a&scoped=true"
import script from "./GaoJing.vue?vue&type=script&lang=js"
export * from "./GaoJing.vue?vue&type=script&lang=js"

import "./GaoJing.vue?vue&type=style&index=0&id=43ae3c9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ae3c9a"]])

export default __exports__